import React from 'react'
import type { CSSProperties } from 'react'
import { motion } from 'framer-motion'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'

import './CornerTagOverlayComponentChyronStyle.scss'

const parent = {
  visible: {
    opacity: 1,
    translateX: '0%',
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.3,
      duration: 0.5,
      ease: 'easeOut',
    },
  },
  hidden: {
    opacity: 0,
    translateX: '150%',
  },
}

const child = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
}

type CornerTagOverlayComponentProps = {
  text: string
}

const CornerTagOverlayComponent = ({
  text,
}: CornerTagOverlayComponentProps) => {
  const { accent } = useWebinarColors()
  return (
    <motion.div
      className="corner-tag-overlay-component-chyron-style"
      variants={parent}
      initial="hidden"
      animate="visible"
      style={
        {
          '--accent-color': accent ?? '#0161ff',
        } as CSSProperties
      }
    >
      <motion.div className="text" variants={child}>
        {text}
      </motion.div>
    </motion.div>
  )
}

export default CornerTagOverlayComponent
